import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const GoogleLogin = ({ onPostLogin, style }) => {
    const navigate = useNavigate();
    useEffect(() => {
        /* Load Google Sign-In Button */
        try {
            window.google.accounts.id.initialize({
                client_id: "527432887365-rq86dgvtjk1rnluc8oolfl5g1bfph0vm.apps.googleusercontent.com",
                callback: handleCredentialResponse,
            });

            window.google.accounts.id.renderButton(
                document.getElementById("googleSignInBtn"),
                {
                    type: "standard",
                    theme: "outline",
                    size: "large",
                    text: "continue_with",
                    shape: "circle",
                    locale: "en-IN"
                });
        } catch (error) {
            setTimeout(() => {
                window.location.reload();
            },2000)
        }
        //eslint-disable-next-line
    }, []);

    const handleCredentialResponse = async (response) => {
        const googleIdToken = response.credential;

        const firebaseResponse = await fetch(
            `https://identitytoolkit.googleapis.com/v1/accounts:signInWithIdp?key=AIzaSyCjDWb8HDWi_tgBw8eFsixXY9iw9uFCisw`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    postBody: `id_token=${googleIdToken}&providerId=google.com`,
                    requestUri: "https://dummystockexchange.com", // Your app's domain
                    returnSecureToken: true,
                }),
            }
        );

        const data = await firebaseResponse.json();
        localStorage.setItem("token", data.oauthIdToken);
        localStorage.setItem("refreshToken", data.refreshToken);
        onPostLogin();
    };

    return (
        <div style={style}>
            <h2 style={{ display: "none" }}>Sign in with Google</h2>
            <div id="googleSignInBtn"></div>
            <button style={{
                marginTop: "12px",
                paddingBlock: "5px",
                backgroundColor: "#6750A4",
                fontSize: "1.2rem",
                color: "white",
                borderRadius: "50px",
                width: "100%",
                border: "none",
                cursor: "pointer"
            }} onClick={() => {
                navigate("/privacy-policy");
            }}>Privacy Policy</button>
        </div>
    );
};

export default GoogleLogin;
